import { XYPointsConverter } from '../Utils/PointsConverter/XYPointsConverter';
import { TerceraChartWindowBase } from './TerceraChartWindowBase';
export var ZoomDirection;
(function (ZoomDirection) {
    ZoomDirection[ZoomDirection["Horizontal"] = 1] = "Horizontal";
    ZoomDirection[ZoomDirection["Vertical"] = 2] = "Vertical";
    ZoomDirection[ZoomDirection["All"] = 3] = "All";
})(ZoomDirection || (ZoomDirection = {}));
var ZoomYAnchor;
(function (ZoomYAnchor) {
    ZoomYAnchor[ZoomYAnchor["None"] = 0] = "None";
    ZoomYAnchor[ZoomYAnchor["Top"] = 1] = "Top";
    ZoomYAnchor[ZoomYAnchor["Bottom"] = 2] = "Bottom";
})(ZoomYAnchor || (ZoomYAnchor = {}));
export class TerceraChartXYWindow extends TerceraChartWindowBase {
    constructor(rightYScaleRenderer, leftYScaleRenderer) {
        super(rightYScaleRenderer, leftYScaleRenderer);
        this.zoomYAnchor = ZoomYAnchor.None;
        this.zoomSensetive = 1;
        this.zoomMode = ZoomDirection.All;
        this.AutoScale = false;
        this.PointsConverter = new XYPointsConverter(this);
        if (!isNullOrUndefined(rightYScaleRenderer)) {
            this.rightYScaleRenderer.window = this;
        }
        if (!isNullOrUndefined(leftYScaleRenderer)) {
            this.leftYScaleRenderer.window = this;
        }
        this.IsMainWindow = true;
    }
    CalcScales() {
        this.CalcXScale();
        return super.CalcScales();
    }
    ZoomIn() {
        if (!this.CanZoomIn()) {
            return;
        }
        let dx = 0;
        let dy = 0;
        if (this.zoomMode & ZoomDirection.Horizontal) {
            dx = Math.abs(this.FmaxFloatX - this.FminFloatX) / (4.0 / this.zoomSensetive);
        }
        if (this.zoomMode & ZoomDirection.Vertical) {
            dy = Math.abs(this.FmaxFloatY - this.FminFloatY) / (4.0 / this.zoomSensetive);
        }
        this.ProcessZoomIn(dx, dy);
        this.CalcScales();
    }
    CanZoomIn() {
        return Math.ceil((this.FmaxXTotal - this.FminXTotal) / (this.FmaxFloatX - this.FminFloatX)) < 16;
    }
    ZoomOut() {
        if (!this.CanZoomOut()) {
            return;
        }
        let dx = 0;
        let dy = 0;
        if (this.zoomMode & ZoomDirection.Horizontal) {
            dx = Math.abs(this.FmaxFloatX - this.FminFloatX) / (2.0 / this.zoomSensetive);
        }
        if (this.zoomMode & ZoomDirection.Vertical) {
            dy = Math.abs(this.FmaxFloatY - this.FminFloatY) / (2.0 / this.zoomSensetive);
        }
        this.ProcessZoomOut(dx, dy);
        this.CalcScales();
    }
    CanZoomOut() {
        return this.FmaxFloatX - this.FminFloatX < this.FmaxXTotal - this.FminXTotal;
    }
    ZoomX(delta) {
        if (delta === 0) {
            return false;
        }
        const isZoomIn = delta < 0;
        const absDelta = Math.abs((delta * (this.FmaxFloatX - this.FminFloatX)) / 2);
        if (isZoomIn) {
            if (this.CanZoomIn()) {
                this.ProcessZoomIn(absDelta, 0);
            }
            return true;
        }
        else {
            if (this.CanZoomOut()) {
                this.ProcessZoomOut(absDelta, 0);
            }
            return true;
        }
    }
    ZoomY(delta) {
        if (delta === 0) {
            return false;
        }
        const isZoomIn = delta < 0;
        const absDelta = Math.abs((delta * (this.FmaxFloatY - this.FminFloatY)) / 2);
        const newMinY = isZoomIn ? this.FminFloatY + absDelta : this.FminFloatY - absDelta;
        const newMaxY = isZoomIn ? this.FmaxFloatY - absDelta : this.FmaxFloatY + absDelta;
        this.updateMinMaxY(isZoomIn, newMinY, newMaxY, false);
        return true;
    }
    MoveX(newMinX, newMaxX) {
        let offset = 0;
        if (newMinX < this.FminXTotal) {
            offset = this.FminXTotal - newMinX;
        }
        else if (newMaxX > this.FmaxXTotal) {
            offset = this.FmaxXTotal - newMaxX;
        }
        this.FminFloatX = newMinX + offset;
        this.FmaxFloatX = newMaxX + offset;
        return true;
    }
    SetMinMaxXScale(newFminFloatX, newFmaxFloatX) {
        this.FminXTotal = this.FminFloatX = newFminFloatX;
        this.FmaxXTotal = this.FmaxFloatX = newFmaxFloatX;
    }
    SetMinMaxYScale(newFminFloatY, newFmaxFloatY) {
        this.FminYTotal = this.FminFloatY = newFminFloatY;
        this.FmaxYTotal = this.FmaxFloatY = newFmaxFloatY;
        if (Math.abs(this.FminYTotal) < Math.abs(this.FmaxYTotal)) {
            this.zoomYAnchor = ZoomYAnchor.Bottom;
        }
        else if (Math.abs(this.FminYTotal) > Math.abs(this.FmaxYTotal)) {
            this.zoomYAnchor = ZoomYAnchor.Top;
        }
        else {
            this.zoomYAnchor = ZoomYAnchor.None;
        }
        this.CalcScales();
    }
    CalcXScale() {
        if (this.FmaxFloatX === this.FminFloatX) {
            this.XScale = 1;
        }
        else {
            this.XScale = this.ClientRectangle.Width / (this.FmaxFloatX - this.FminFloatX);
        }
    }
    ProcessZoomIn(dx, dy) {
        const newMinFloatX = this.FminFloatX + dx;
        const newMaxFloatX = this.FmaxFloatX - dx;
        let newMinFloatY = this.FminFloatY;
        let newMaxFloatY = this.FmaxFloatY;
        switch (this.zoomYAnchor) {
            case ZoomYAnchor.Bottom:
                newMaxFloatY -= dy * 2;
                break;
            case ZoomYAnchor.Top:
                newMinFloatY += dy * 2;
                break;
            default:
                newMaxFloatY -= dy;
                newMinFloatY += dy;
                break;
        }
        this.updateMinMaxX(true, newMinFloatX, newMaxFloatX);
        this.updateMinMaxY(true, newMinFloatY, newMaxFloatY);
    }
    ProcessZoomOut(dx, dy) {
        const newMinFloatX = this.FminFloatX - dx;
        const newMaxFloatX = this.FmaxFloatX + dx;
        let newMinFloatY = this.FminFloatY;
        let newMaxFloatY = this.FmaxFloatY;
        switch (this.zoomYAnchor) {
            case ZoomYAnchor.Bottom:
                newMaxFloatY += dy * 2;
                break;
            case ZoomYAnchor.Top:
                newMinFloatY -= dy * 2;
                break;
            default:
                newMaxFloatY += dy;
                newMinFloatY -= dy;
                break;
        }
        this.updateMinMaxX(false, newMinFloatX, newMaxFloatX);
        this.updateMinMaxY(false, newMinFloatY, newMaxFloatY);
    }
    updateMinMaxX(isZoomIn, newMinFloatX, newMaxFloatX) {
        const correctedMinMax = isZoomIn
            ? this.CorrectMinMaxXForZoomIn(newMinFloatX, newMaxFloatX)
            : this.CorrectMinMaxXForZoomOut(newMinFloatX, newMaxFloatX);
        this.FminFloatX = correctedMinMax.newMinFloatX;
        this.FmaxFloatX = correctedMinMax.newMaxFloatX;
    }
    updateMinMaxY(isZoomIn, newMinFloatY, newMaxFloatY, isCheckBorders = true) {
        const correctedMinMax = isZoomIn
            ? this.CorrectMinMaxYForZoomIn(newMinFloatY, newMaxFloatY)
            : this.CorrectMinMaxYForZoomOut(newMinFloatY, newMaxFloatY, isCheckBorders);
        this.FminFloatY = correctedMinMax.newMinFloatY;
        this.FmaxFloatY = correctedMinMax.newMaxFloatY;
    }
    CorrectMinMaxXForZoomOut(newMinFloatX, newMaxFloatX) {
        let dx = 0;
        let minX = newMinFloatX;
        let maxX = newMaxFloatX;
        if (newMinFloatX < this.FminXTotal) {
            dx = this.FminXTotal - minX;
            minX += dx;
            maxX = Math.min(maxX + dx, this.FmaxXTotal);
        }
        if (newMaxFloatX > this.FmaxXTotal) {
            dx = maxX - this.FmaxXTotal;
            maxX -= dx;
            minX = Math.max(minX - dx, this.FminXTotal);
        }
        return {
            newMinFloatX: minX,
            newMaxFloatX: maxX
        };
    }
    CorrectMinMaxXForZoomIn(newMinFloatX, newMaxFloatX) {
        return {
            newMinFloatX: Math.min(newMinFloatX, this.FmaxFloatX),
            newMaxFloatX: Math.max(newMaxFloatX, this.FminFloatX)
        };
    }
    CorrectMinMaxYForZoomOut(newMinFloatY, newMaxFloatY, isCheckBorders = true) {
        if (isCheckBorders && !this.CanZoomOut()) {
            return {
                newMinFloatY: this.FminYTotal,
                newMaxFloatY: this.FmaxYTotal
            };
        }
        else {
            return {
                newMinFloatY,
                newMaxFloatY
            };
        }
    }
    CorrectMinMaxYForZoomIn(newMinFloatY, newMaxFloatY) {
        return {
            newMinFloatY: Math.max(newMinFloatY, this.FminYTotal),
            newMaxFloatY: Math.min(newMaxFloatY, this.FmaxYTotal)
        };
    }
    CalculateMovingXOffset(movingDeltaX, width) {
        return (movingDeltaX * (this.FmaxXTotal - this.FminXTotal)) / width + this.FminXTotal;
    }
}
